import siteConfig from "site-config";
import { Observable } from "rxjs";
import { ajax } from "lib/observable";
import { formatMessage } from "lib/globalize-util";
import "rxjs/add/operator/map";
import { COLLECTIONS } from "constants/action-types";
import { add as snackbarAdd } from "actions/snackbars";
import * as actions from "actions/collections";
import {
    Collections as CollectionsSchema,
    CollectionPermissions as CollectionPermissionsSchema,
} from "schemas/collections";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import { updateEntities } from "redux-query";
import querystring from "querystring";
import { SizingErrors, SizeRangesErrors } from "constants/product-collection";
import { setAssortmentError } from "actions/collections";
import { get } from "lodash";

interface IFetchOptions {
    limit?: number;
    max_granted_at_ms?: string;
}

export const fetchCollectionsEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.FETCH.START)
        .map(({ payload }) => payload)
        .switchMap(({ userId, options = {} }) => {
            let url = `${siteConfig.goAPI}/v1/users/${userId}/collections?`;

            if ("limit" in options === false) {
                (options as IFetchOptions).limit = 25;
            }
            url = url + querystring.stringify(options);

            return (
                ajax(url)
                    .map(({ response }) => {
                        if (!response) {
                            return { result: [] };
                        } else {
                            response.data = response.data.filter((collection) => !!collection.permissions.length);

                            const collectionRecords = getRecordsFromSchema(CollectionsSchema);
                            const collectionData = normalizeData(response, CollectionsSchema, collectionRecords);
                            const permissionRecords = getRecordsFromSchema(CollectionPermissionsSchema);
                            const permissionData = normalizeData(
                                response,
                                CollectionPermissionsSchema,
                                permissionRecords
                            );

                            return {
                                entities: {
                                    collections: collectionData.entities,
                                    permissions: permissionData.entities,
                                },
                                result: collectionData.result,
                            };
                        }
                    })
                    .mergeMap(({ entities, result }: any) => [
                        updateEntities({
                            collectionPermissions: (collectionPermissions = {}) => {
                                return {
                                    ...collectionPermissions,
                                    ...entities.permissions.collectionPermissions,
                                };
                            },
                            collections: (collections = {}) => {
                                return {
                                    ...collections,
                                    ...entities.collections.collections,
                                };
                            },
                        }),
                        actions.fetchCollectionsSuccess(result),
                    ])
                    // .takeUntil(action$.ofType(WHITEBOARD_BOARDS_CLEAR)) // route navigation cancellation
                    .catch((error) => {
                        return Observable.merge(
                            Observable.of(actions.fetchCollectionsError(error, true)),
                            Observable.of(
                                snackbarAdd({ message: formatMessage("There was an error fetching collections") })
                            )
                        );
                    })
            );
        });

const assortmentErrosHash: string[] = [
    SizingErrors.CurveNotFound,
    SizingErrors.DoorCurveNotFound,
    SizingErrors.SizeTotalsDotNotMatchBulks,
    SizeRangesErrors.SizeRangesDoNotMatch,
    SizeRangesErrors.SizeRangesNotFound,
];

export const lookupAssortmentErrorsEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.ERROR.ALLOCATION_LOOK_UP_ERROR)
        .map(({ payload }) => payload)
        .switchMap(({ assortmentsData = [] }) => {
            let hasAssoermentError = false;

            if (!assortmentsData || !assortmentsData.length) {
                const {
                    collection: { gridApi },
                } = store.getState();
                let fieldNames = [];

                const ids = [];
                gridApi.forEachNode(({ data }) => {
                    // Only allocate node that is NOT proxy OR first proxy (index=0) to prevent duplicate
                    if (data && !data.proxyIndex) {
                        ids.push(data.fields.id.string_value);
                    }
                });

                hasAssoermentError = ids.some((id) => {
                    const { data } = gridApi.getRowNode(id);
                    if (!fieldNames.length) {
                        fieldNames = Object.keys(data.fields);
                    }
                    return fieldNames.some((key) =>
                        assortmentErrosHash.includes(get(data, ["fields", key, "string_value"]))
                    );
                });
            } else {
                hasAssoermentError = assortmentsData.some((assortmentData) => {
                    return Object.keys(assortmentData).some((key) => assortmentErrosHash.includes(assortmentData[key]));
                });
            }

            return Observable.of(
                setAssortmentError(
                    hasAssoermentError ? formatMessage("This assortment contains one or more errors.") : null
                )
            );
        });
